import { FC, useContext } from "react";
import { Container, Tab } from "semantic-ui-react";

import VenueConfigs from "./VenueConfigs/VenueConfigs";
import SQSConfig from "./SQSConfig/SQSConfig";
import { AuthContext } from "../../components/Authentication";
import isAvailable from "../../api/utils";

const ConfigsTabPanes: FC = () => {
    const { user } = useContext(AuthContext);
    if (!user) {
        return <div>Not authenticated.</div>;
    }

    const panes = [
        {
            menuItem: { content: "Venues", disabled: !isAvailable(["configs/index"], user) },
            render: () => (
                <Tab.Pane>
                    <VenueConfigs />
                </Tab.Pane>
            ),
        },
        {
            menuItem: { content: "SQS", disabled: !isAvailable(["configs/get_sqs_config"], user) },
            render: () => (
                <Tab.Pane>
                    <SQSConfig />
                </Tab.Pane>
            ),
        },
    ];

    return (
        <Container style={{ margin: "20px 0 0 0" }}>
            <Tab panes={panes} />
        </Container>
    );
};

export default ConfigsTabPanes;
